export default __webpack_public_path__ + "static/char-s-31-zh-Hant-cba48018adffab73fc770393ab01f923.png";